(function (globals) {

    "use strict";

    BrandsPredefinedSetEditModalController.$inject = ["$scope", "modalData", "brandsPredefinedSetsService"];
    function BrandsPredefinedSetEditModalController($scope, modalData, brandsPredefinedSetsService) {

        var self = this;

        self.loading = false;
        self.title = modalData.predefinedSet.title;
        self.set = angular.copy(modalData.predefinedSet);

        self.close = function () {
            if (self.loading) {
                return;
            }
            $scope.$hide();
        };

        self.delete = function () {
            self.loading = true;
            self.deleteing = true;
            brandsPredefinedSetsService
                .deletePredefinedSet(modalData.groupId, modalData.predefinedSet.id)
                .then(function (result) {
                    modalData.onChange();
                    $scope.$hide();
                })
                .catch(function (err) {
                    console.error(err)
                })
                .finally(function () {
                    self.loading = false;
                    self.deleteing = false;
                })
        };

        self.rename = function () {
            self.loading = true;
            self.saving = true;
            brandsPredefinedSetsService
                .updatePredefinedSet(modalData.groupId, modalData.predefinedSet.id, self.title,  modalData.predefinedSet.brands)
                .then(function (result) {
                    modalData.onChange();
                    $scope.$hide();
                })
                .catch(function (err) {
                    console.error(err)
                })
                .finally(function () {
                    self.loading = false;
                    self.saving = false;
                })
        };
    }

    globals.getBrandsPredefinedSetEditModal = function (modalData) {
        return {
            controller: BrandsPredefinedSetEditModalController,
            controllerAs: '$ctrl',
            templateUrl: '../hmodules/brands-predefined-sets/modals/brands-predefined-set-edit/brands-predefined-set-edit.modal.html',
            show: true,
            backdrop: 'static',
            resolve: {
                modalData: modalData
            }
        };
    };

})(window);




